import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.regexp.split";

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../services/apiService/lambda';
import inputRules from '../../mixins/input-rules';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import { get } from 'lodash';
export default {
  name: 'CoreScriptEditor',
  components: {
    codemirror: codemirror
  },
  mixins: [inputRules],
  model: {
    prop: 'script',
    event: 'update:script'
  },
  props: {
    script: {
      type: String,
      required: false,
      default: ''
    },
    scriptType: {
      type: String,
      required: false,
      default: 'javascript'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    scriptParamsTransformer: {
      type: Function,
      required: false,
      default: null
    },

    /**
     * Specify a function to evaluate the script
     * This will be used instead of the default evaluation function
     * @type {Function}
     * @default null
     * @example
     * evaluationFunction: (payload, additionalFormData) => { return { result: script(payload), logs: ['info: log message'], error: null } }
     */
    evaluationFunction: {
      type: Function,
      required: false,
      default: null
    },
    hideScriptTypeSelector: {
      type: Boolean,
      required: false,
      default: false
    },
    hidePayloadInputs: {
      type: Boolean,
      required: false,
      default: false
    },
    fixedPayloadType: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      result: '',
      error: '',
      logs: [],
      showResult: false,
      formIsValid: false,
      payloadType: 'HEX',
      payload: '',
      isParsing: false,
      scriptInternal: this.script,
      scriptTypeInternal: this.scriptType
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled', 'UiTheme'])), {}, {
    payloadValidationError: function payloadValidationError() {
      if (!this.payload) {
        return undefined;
      }

      if (this.actualPayloadType === 'HEX' && this.hexPayloadIsValid) {
        return undefined;
      }

      if (this.actualPayloadType === 'JSON' && this.jsonPayloadIsValid) {
        return undefined;
      }

      return this.$i18n_t('Core.ScriptEditor.payloadTypeError');
    },
    hexPayloadIsValid: function hexPayloadIsValid() {
      if (!this.payload) {
        return false;
      }

      var payloadHasEvenLength = this.payload.length % 2 === 0;

      if (!payloadHasEvenLength) {
        return false;
      }

      var payloadHasOnlyHexChars = /^[a-fA-F0-9]+$/.exec(this.payload) !== null;
      return payloadHasOnlyHexChars;
    },
    jsonPayloadIsValid: function jsonPayloadIsValid() {
      if (!this.payload) {
        return false;
      }

      try {
        JSON.parse(this.payload);
        return true;
      } catch (_unused) {
        return false;
      }
    },
    cmOptions: function cmOptions() {
      return {
        readOnly: this.readOnly ? 'nocursor' : false,
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      };
    },
    actualPayloadType: function actualPayloadType() {
      if (this.fixedPayloadType) {
        return this.fixedPayloadType;
      }

      return this.payloadType;
    }
  }),
  watch: {
    script: {
      handler: function handler() {
        this.scriptInternal = this.script;
        this.refreshCM();
      },
      immediate: true
    },
    scriptType: {
      handler: function handler() {
        this.scriptTypeInternal = this.scriptType;
        this.refreshCM();
      },
      immediate: true
    },
    scriptTypeInternal: function scriptTypeInternal() {
      this.emitChanges();
    },
    scriptInternal: function scriptInternal() {
      var _this = this;

      this.emitChanges(); // clear codemirror line classes

      if (this.$refs.codemirror) {
        var lineNumber = 0;
        this.$refs.codemirror.codemirror.doc.eachLine(function () {
          _this.$refs.codemirror.codemirror.removeLineClass(lineNumber, 'background', 'codemirrorScriptEditorSyntaxError');

          lineNumber++;
        });
      }
    }
  },
  mounted: function mounted() {
    this.refreshCM();
  },
  methods: {
    emitChanges: function emitChanges() {
      this.$emit('update:script-type', this.scriptTypeInternal);
      this.$emit('update:script', this.scriptInternal);
    },
    logStyle: function logStyle(logMessage) {
      var logType = logMessage.split(':')[0];

      switch (logType) {
        case 'log':
          return '';

        case 'info':
          return 'color: deepskyblue;';

        case 'warn':
          return 'color: orange;';

        case 'error':
          return 'color: red;';

        case 'debug':
          return 'color: gray;';

        default:
          return '';
      }
    },
    copySuccess: function copySuccess() {
      this.$snack(this.$i18n_t('Common.copyToClipboardSuccess'), 'success');
    },
    // eslint-disable-next-line max-statements
    evaluateScript: function () {
      var _evaluateScript = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var formData, paramsFromForm, parsedPayload, nextResult, nextError, nextLogs, response, params, hasTranslation;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData(this.$refs.testForm.$el);
                paramsFromForm = Object.fromEntries(formData);
                parsedPayload = this.payload;
                _context.t0 = this.actualPayloadType;
                _context.next = _context.t0 === 'JSON' ? 6 : _context.t0 === 'HEX' ? 8 : 9;
                break;

              case 6:
                parsedPayload = JSON.parse(this.payload);
                return _context.abrupt("break", 10);

              case 8:
                return _context.abrupt("break", 10);

              case 9:
                throw new Error('Unknown payload type');

              case 10:
                nextResult = '';
                nextError = '';
                nextLogs = [];
                _context.prev = 13;
                this.isParsing = true;

                if (!(typeof this.evaluationFunction === 'function')) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return this.evaluationFunction(parsedPayload, paramsFromForm);

              case 18:
                response = _context.sent;
                _context.next = 26;
                break;

              case 21:
                params = [parsedPayload];

                if (typeof this.scriptParamsTransformer === 'function') {
                  params = this.scriptParamsTransformer(parsedPayload, paramsFromForm);
                }

                _context.next = 25;
                return ApiService.evaluateScript({
                  script: this.scriptInternal,
                  scriptParams: params
                });

              case 25:
                response = _context.sent;

              case 26:
                if (!response) {
                  response = {
                    error: 'No response from server'
                  };
                }

                nextResult = this.$i18n_t('Core.ScriptEditor.tester.noResponse');

                if (response.result !== undefined) {
                  nextResult = response.result;
                  nextError = '';
                }

                if (response.error !== undefined && response.error !== null) {
                  nextError = response.error;
                  nextResult = '';
                }

                nextLogs = response.logs;
                _context.next = 40;
                break;

              case 33:
                _context.prev = 33;
                _context.t1 = _context["catch"](13);
                nextResult = '';

                if (!_context.t1.isAxiosError) {
                  _context.next = 39;
                  break;
                }

                nextError = get(_context.t1, 'response.data', _context.t1.message);
                return _context.abrupt("return");

              case 39:
                nextError = _context.t1;

              case 40:
                _context.prev = 40;
                this.isParsing = false;

                if (nextError && typeof nextError === 'string') {
                  hasTranslation = this.$i18n_te("Error.".concat(nextError));

                  if (!hasTranslation) {
                    nextError = nextError.split('[Line ').map(function (linePart) {
                      var _linePart$split = linePart.split(']'),
                          _linePart$split2 = _toArray(_linePart$split),
                          lineNumber = _linePart$split2[0],
                          rest = _linePart$split2.slice(1);

                      var parsedLineNumber = parseInt(lineNumber, 10);

                      if (isNaN(parsedLineNumber)) {
                        return linePart;
                      }

                      var actualLineNumber = parsedLineNumber - 23;

                      if (_this2.$refs.codemirror) {
                        _this2.$refs.codemirror.codemirror.addLineClass(actualLineNumber, 'background', 'codemirrorScriptEditorSyntaxError');
                      }

                      return "".concat(actualLineNumber, "] ").concat(rest.join(']'));
                    }).join('[Line ');
                  } else {
                    this.error = this.$i18n_t("Error.".concat(nextError));
                  }
                }

                this.result = nextResult;
                this.error = nextError;
                this.logs = nextLogs;
                this.showResult = true;
                return _context.finish(40);

              case 48:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 33, 40, 48]]);
      }));

      function evaluateScript() {
        return _evaluateScript.apply(this, arguments);
      }

      return evaluateScript;
    }(),
    validateForm: function validateForm() {
      this.$refs.testForm.validate();
    },
    refreshCM: function () {
      var _refreshCM = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$nextTick();

              case 2:
                _context2.next = 4;
                return this.$nextTick();

              case 4:
                if (this.$refs.codemirror) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:
                // required workaround to get the cursor appearing at the right spot
                // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
                this.$refs.codemirror.codemirror.refresh();
                this.$refs.codemirror.codemirror.focus();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshCM() {
        return _refreshCM.apply(this, arguments);
      }

      return refreshCM;
    }()
  }
};